import React from 'react';
import UpdateClaimStatus from './UpdateClaimStatus';

/** Add New Claim — same wizard as Update Claim */
const EnhancedClaimForm = ({ memberId, memberName, member, onClose, onSuccess }) => {
  const resolvedMember = member || { id: memberId, name: memberName };

  return (
    <UpdateClaimStatus
      mode="create"
      claim={null}
      member={resolvedMember}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};

export default EnhancedClaimForm;
